import { styled } from '@mui/material/styles';
import SortableTableHead from 'Components/TableBase/SortableTableHead';
import { StyledTable } from 'Components/TableBase/Table';
import React, { FC, ReactNode } from 'react';
import { ImpactClaim } from 'FeatureModules/Request/types/impactClaim.types';
import ImpactClaimTableBody from './ImpactClaimTableBody';
import IMPACT_CLAIM_TABLE_HEADER_COLUMNS from 'FeatureModules/ImpactClaim/utils/headerColumns';

interface IImpactClaimTableProps {
  impactClaims: ImpactClaim[];
  hideHeader?: boolean;
  displayGroup?: boolean;
  actions?: TableAction[];
  onSelect: (id: string) => void;
  'data-testId'?: string;
}

export interface TableAction {
  icon: ReactNode;
  tooltip: string;
  dataCy?: string;
  onClick: (impactClaim: ImpactClaim) => void;
}

const Table = styled(StyledTable)(({ theme }) => ({
  minWidth: 1100,
  marginBottom: theme.spacing(1),
}));

const ImpactClaimTable: FC<IImpactClaimTableProps> = ({
  impactClaims,
  hideHeader,
  displayGroup = true,
  actions,
  onSelect,
  'data-testId': dataCy = '',
}) => {
  return (
    <Table aria-labelledby="tableTitle" aria-label="enhanced table" data-testid={dataCy}>
      {!hideHeader && <SortableTableHead headerColumns={IMPACT_CLAIM_TABLE_HEADER_COLUMNS} />}
      <ImpactClaimTableBody
        data-testid={dataCy}
        impactClaims={impactClaims}
        displayGroup={displayGroup}
        actions={actions}
        onSelect={onSelect}
      />
    </Table>
  );
};

export default ImpactClaimTable;
